import { z } from 'zod';
import { apiGet, apiPost, apiSend } from '@/lib/api';

/**
 * SŁOWNIK DOSTAWCÓW — `Suppliers` z SPS.
 *
 * ⚠️⚠️ `doPrzypisania` MÓWI, CZY TEGO DOSTAWCĘ DA SIĘ W OGÓLE WYBRAĆ NA TOWARZE. Klucz w `Suppliers`
 * ma 255 znaków, a kolumna dostawcy na towarze — 32, więc SPS pozwala założyć dostawcę, którego
 * nie da się nigdzie użyć. Liczy to portal, bo to on zna schemat; ekran ma tylko o tym powiedzieć.
 */
export const DostawcaSchema = z.object({
  id: z.string(),
  supplierNumber: z.string(),
  name: z.string().nullable(),
  addr1: z.string().nullable(),
  addr2: z.string().nullable(),
  addr3: z.string().nullable(),
  addr4: z.string().nullable(),
  towarow: z.number(),
  doPrzypisania: z.boolean(),
});

export type Dostawca = z.infer<typeof DostawcaSchema>;

export const fetchDostawcy = (groupId: string) =>
  apiGet(
    `/suppliers?groupId=${encodeURIComponent(groupId)}`,
    z.object({
      dostawcy: z.array(DostawcaSchema),
      /** Ile towarów wskazuje na numer spoza słownika — u klienta stan poprawny. */
      spozaSlownika: z.number(),
    }),
  );

export const zalozDostawce = (
  groupId: string,
  dane: { supplierNumber: string; name?: string; addr1?: string; addr2?: string; addr3?: string; addr4?: string },
) => apiPost('/suppliers', { groupId, ...dane }, z.object({ opId: z.string() }));

export const zmienDostawce = (
  groupId: string,
  id: string,
  dane: { name?: string; addr1?: string; addr2?: string; addr3?: string; addr4?: string },
) => apiSend('PATCH', `/suppliers/${id}`, { groupId, ...dane }, z.object({ opId: z.string() }));

/**
 * USUNIĘCIE DOSTAWCY. `wyczyscTowary` = zgoda na zdjęcie go z towarów, które go mają — bez niej
 * portal odmawia, gdy takie towary są. Ekran pyta o nią z liczbą towarów.
 */
export const usunDostawce = (groupId: string, id: string, wyczyscTowary: boolean) =>
  apiPost(`/suppliers/${id}/usun`, { groupId, wyczyscTowary }, z.object({ opId: z.string(), towarow: z.number() }));
